const libPictView = require('pict-view');

/** @type {any} */
const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-SamplesPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class HeadlightPaneSamples extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Render one tab's view without letting its failure take the sibling tabs with it.
	 *
	 * These run as a serial chain, so an unguarded throw in the first tab leaves every later tab
	 * unrendered and the pane's open callback unfired.
	 * @param {string} pViewName - The view to render
	 * @return {void}
	 */
	renderTabView(pViewName)
	{
		try
		{
			this.pict.views[pViewName].renderAsync(false, false, false, false, (pError) =>
			{
				if (pError)
				{
					this.log.error(`Failed to render the ${pViewName} tab: ${pError?.message || pError}`);
					return;
				}
				this.log.info(`${pViewName} view rendered`);
			});
		}
		catch (pError)
		{
			this.log.error(`Failed to render the ${pViewName} tab: ${pError?.message || pError}`);
		}
	}

	onAfterRenderAsync(pCallback)
	{
		// set the callback that runs when the search results are returned
		this.pict.views.SampleSearch.setSampleSearchResultsCallback((pResults) =>
		{
			// collapse the filter panel
			this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('SampleSearchFilters', 'close');
			// render the pagination controls
			this.pict.views.SampleSearch.renderAsync('SampleSearch-Results', '#SampleSearch-Results-Container', false, false, () =>
			{
				// TODO: is this the proper location for this? Should we be using the Entity object?
				const tmpSamples = this.AppData?.DocumentData?.ReportData?.Samples;
				if (tmpSamples)
				{
					// for each Sample, if the Sample is already included, toggle the button to "on"
					pResults.forEach((pResult) =>
					{
						if (tmpSamples.find((obs) => obs.IDSample === pResult.IDSample))
						{
							document.querySelector(`[data-sample-add-context="${pResult.IDSample}"]`)?.classList?.add('is-active');
						}
					});
				}
			});
		});
		// set the default search filter options for the sample search view
		this.pict.views.SampleSearch.setCurrentSearchFilters({
			PageSize: 20,
		});
		// render each tab's view; a failure in one must not strand the others
		// (SampleCurrent's data still loads lazily, when its tab is opened)
		this.renderTabView('SampleSearch');
		this.renderTabView('SampleCreate');
		this.renderTabView('SampleScan');
		this.renderTabView('SampleCurrent');

		// the panel opens in this callback, so we need to wait for it to open before we can build the included samples list
		if (pCallback)
		{
			pCallback();
		}
	}

	closeHandler()
	{
		this.pict.providers.QRCodeProvider.stopWorkflow();
		this.pict.providers.QRCodeProvider.closeScanner();
	}

	/**
	 * This function is used to set the callback that is run when a sample is selected from the search results.
	 * @param {function} fCallback - The callback function to run when a sample is selected
	 * @return {void}
	 */
	setSampleSelectionCallback(fCallback)
	{
		this.pict.views.SampleSearch.sampleSelectionCallback = fCallback;
	}

	/**
	 * This function is used to handle the opening of the Sample panel from the advanced button.
	 * @param {Event} event - The event that triggered the opening of the Sample panel
	 */
	openSamplePanelFromAdvancedButton(event)
	{
		if (event && event.target instanceof HTMLElement)
		{
			event.preventDefault();
			// find the parent column of the advanced button
			const tmpParentColumn = event.target.closest('.column');
			// if the parent column exists
			if (tmpParentColumn)
			{
				this.fable.HeadlightPanels.applyUIHighlight(tmpParentColumn);
			}
		}
		this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'open', () =>
		{
			this.pict.ContentAssignment.setAttribute('#HeadlightPanels-SamplePanel', 'data-panel-mode', 'add-to-set');
		});
	}

	/**
	 * Open the Samples panel straight to the Current tab. Entry point for the navbar Current Samples
	 * button, which is only visible when this document actually has Samples joined to it.
	 * @param {Event} [event] - The click event
	 * @return {void}
	 */
	openCurrentSamplesTab(event)
	{
		if (event)
		{
			event.preventDefault();
		}
		this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'open', () =>
		{
			this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Current', 'Sample');
			this.pict.views.SampleCurrent.handleTabOpened();
		});
	}

	/**
	 * This function is used to clear the Sample panel target and the banner on the header. The removes the "add mode" flow.
	 * @return {void}
	 */
	clearSamplePanelTarget()
	{
		this.AddImageTargetView = '';
		this.AddImageTargetInput = '';
		this.pict.views.HeadlightPanels.ModePanelLeft = '';
		this.pict.views.HeadlightPanels.ModePanelRight = '';
		// set the "add to content" mode on the panel to show the "add" buttons
		document.getElementById('HeadlightPanels-SamplePanel').setAttribute('data-panel-mode', '');
		// hide the banner on the header that you are adding an Sample
		document.getElementById('HeadlightPanels-SamplePanel-Sample-Header-Mode-Target').innerText = '';
	}
}

module.exports = HeadlightPaneSamples;
// additional view-specific templates
const viewSpecificTemplates = [
];

// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Templates = [ ..._ViewConfiguration.Templates, ...viewSpecificTemplates ];
module.exports.default_configuration = _ViewConfiguration;
